module.exports = __webpack_public_path__ + "4e956fb2abe932a0039c740cc225b1f5.MP3";